import type { CustomerTimelineEntry } from "@repo/app-types/entities/performanceCustomer";
import type { CustomerTimelineRow } from "@repo/ui/customerTimeline/customerTimeline";
import { CustomerTimelineIconNode } from "@repo/ui/customerTimeline/customerTimelineNodes";
import { PH_MASK_CLASS } from "../../analytics/sessionRecordingMasking.js";
import { buildActivityEntryRow } from "./activityRow.js";
import { renderCallEventRow } from "./callEventRow.js";
import { renderCallRow } from "./callRow.js";
import { renderTextConversationRow } from "./textConversationRow.js";
import {
  buildEntryRowId,
  formatCustomerTimelineTime,
  type CustomerTimelineRowOptions,
  type InteractionRowParts,
} from "./timelineRowHelpers.js";

/**
 * The timeline row for an entry. Interaction rows have a file per kind here;
 * activity rows are built in activityRow.
 */
export function buildCustomerTimelineRow(
  entry: CustomerTimelineEntry,
  options: CustomerTimelineRowOptions,
): CustomerTimelineRow {
  switch (entry.type) {
    case "call":
      return buildInteractionRow(entry, renderCallRow(entry, options));
    case "call_event":
      return buildInteractionRow(entry, renderCallEventRow(entry));
    case "text_conversation":
      return buildInteractionRow(
        entry,
        renderTextConversationRow(entry, options),
      );
    case "task_created":
    case "task_canceled":
    case "task_failed":
    case "outreach_finished":
    case "opted_out":
      return buildActivityEntryRow(entry);
  }
}

function buildInteractionRow(
  entry: CustomerTimelineEntry,
  parts: InteractionRowParts,
): CustomerTimelineRow {
  return {
    id: buildEntryRowId(entry),
    dateTime: entry.at,
    dateLabel: formatCustomerTimelineTime(entry.at),
    node: <CustomerTimelineIconNode icon={parts.icon} />,
    details: <div className={PH_MASK_CLASS}>{parts.details}</div>,
  };
}
